<div
	class="checkbox-rating"
	[ngClass]="{
		'opacity-50 grayscale': isDisabled,
	}"
	[attr.aria-disabled]="isDisabled"
>
	@if (label) {
		<div class="checkbox-rating-header">
			<span>{{ label }}</span>
		</div>
	}
	<div class="checkbox-rating-content">
		<div>
			<div class="checkbox-item">
				<mat-checkbox [checked]="currentValue === -1" (change)="select($event)" value="-1" [disabled]="isDisabled">
				</mat-checkbox>
				<label class="text-sm font-bold text-yellow md:text-xl">N/A</label>
			</div>
		</div>
		@for (step of stepsArray; track step) {
			<div>
				<div class="checkbox-item">
					<mat-checkbox
						[checked]="currentValue === step"
						(change)="select($event)"
						[disabled]="isDisabled"
						value="{{ step }}"
					>
					</mat-checkbox>
					<label class="text-sm font-bold text-teal md:text-xl">{{ step }}</label>
				</div>
			</div>
		}
		<div>
			<div class="checkbox-item">
				<mat-checkbox [checked]="currentValue === 0" (change)="select($event)" [disabled]="isDisabled" value="0">
				</mat-checkbox>
				<label class="text-sm font-bold text-red md:text-xl">Incomplete</label>
			</div>
		</div>
	</div>
</div>
